import { gql } from "@apollo/client";

export const loadKeywordGroupById = gql`
  query LoadKeyWordGroupById($id: ID!) {
    loadKeyWordGroupById(id: $id) {
      id
      name
      type
      slug
      imageUrl
      keywords
      keywordsGroupIds
      category
      deleted
      metadata
      isLinked
      linkedTo {
        attachedTo
        id
        name
      }
    }
  }
`;

export const getProductDeleteLinks = gql`
  query GetProductDeleteLinks($id: ID!) {
    loadKeyWordGroupById(id: $id) {
      id
      name
      isLinked
      linkedTo {
        attachedTo
      }
    }
  }
`;
